//REACT AND REACT BASED LIBRARIES
import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useSWRMutation from "swr/mutation";
//COMPONENTS
import Table from "@components/Table";
import { Box, Container } from "@mui/material";
import AnimationFadeIn from "@components/AnimationFadeIn";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import BackgroundImage from "@components/BackgroundImageCst";
//CUSTOM HOOKS AND UTILS
import { useFetchDetail } from "@hooks/useFetchDetail";
import { downloadFile, ServicesURL, uploadFile } from "@utils/utilsApi";
import { useFetchMock } from "src/mock_data/useMockData";
import { MethodType } from "src/services/type";
import { PagesID } from "@utils/utilsConfigurations";
import { fetcher } from "src/services/config";
import { ActionsType } from "src/interfaces/Common";
import ButtonBackPage from "@components/ButtonBackPage";
import DownloadIcon from "@mui/icons-material/Download";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { useAuth } from "@context/auth";
import { useFilters } from "@context/filters";

//LEGENDA
// !! IMPORTANTE/ CORE PAGINA
// ?? FACOLTATIVO/ DIPENDE DALLA NECESSITÀ
// ## USATO PER DATI MOCKATI, NON NECESSARIO UNA VOLTA RICEVUTI I SERVIZI BE

const HistoryRegister: React.FC = () => {
  //!! HOOK PER GESTIRE TRADUZIONI
  const { t } = useTranslation(["history-virtual-register-page"]); //NECESSARIO AGGIORNARE FILES DI TRADUZIONE

  //?? HOOK PER PARAMETRI DA URL (IL NOME è LO STESSO DI QUELLO INSERITO IN ROUTER es. /:idLO)
  const { id = "1", idEdition } = useParams();
  const { user } = useAuth();
  const { filters } = useFilters();
  const filterId = `${user?.id_user}_${PagesID["corporate.virtual-register.history"]}`;
  const { pathname } = useLocation();

  const [openModalConfirm, setOpenModalConfirm] = useState<boolean>(false);

  //!! CHIAMATA GET
  const { columns, dataTable, actionsTopToolbar } = useFetchTable(
    `${ServicesURL.getVirtualRegisterHistory}?corporateId=${id}&editionId=${idEdition}`, //!! (SOLO DI ESEMPIO) MODIFICARE SERVICE URL CON QUELLO INSERITO NEL FILE DI CONFIG
    PagesID["corporate.virtual-register.history"], //!! (SOLO DI ESEMPIO) MODIFICARE PAGE ID CON QUELLO INSERITO NEL FILE DI CONFIG
    filters[filterId],
  );

  const { dataDetail: dataEdition } = useFetchDetail(
    `${ServicesURL.getEditionsDetail}${pathname.includes("physical-editions") ? "/physical" : "/virtual"}`,
    idEdition + `?corporateId=${id}` || "",
    pathname.includes("physical-editions")
      ? PagesID["corporate.physical-editions"]
      : PagesID["corporate.virtual-editions"],
  );

  const actionsToolbar: ActionsType[] | undefined = React.useMemo(() => {
    return actionsTopToolbar?.map((action: ActionsType) => {
      switch (action.type) {
        case "button":
          return {
            ...action,
            getIcon: () => <DownloadIcon />,
            callBack: () => setOpenModalConfirm(true),
          };
        default:
          return action;
      }
    });
  }, [actionsTopToolbar]);

  const handleDownload = () => {
    setOpenModalConfirm(!openModalConfirm);
    downloadFile(
      `${ServicesURL.getVirtualRegisterHistoryFile}?corporateId=${id}&editionId=${idEdition}`,
      false,
      "",
      { responseType: "blob" },
    );
  };

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-certificates.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={`${dataEdition && dataEdition?.edition_code ? `${dataEdition?.edition_code} - ` : ""}${t("hero-title")}`}
          description={t("hero-description")}
        />
        <ButtonBackPage customRedirect={-1} />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          <Table
            id={PagesID["corporate.virtual-register.history"]}
            data={dataTable?.output || []}
            columns={columns || []}
            configurationTopToolbar={actionsToolbar}
            configurationActionForRow={[]}
            totalPages={dataTable?.metadata?.total_elements}
            modalTitle={t("hero-title")?.replace("-", "") || ""}
            enableRowActions={false}
            hiddenFilters={true}
          />
        </Box>
      </Container>
      <ModalConfirmsCst
        open={!!openModalConfirm}
        title={t("confirm-modal-download.hero-title")}
        description={t("confirm-modal-download.hero-description")}
        routeToSamePage={true}
        onCallBackClosed={() => {
          setOpenModalConfirm(!openModalConfirm);
        }}
        onActionConfirmed={() => handleDownload()}
      />
    </AnimationFadeIn>
  );
};

export default HistoryRegister;
